module.exports = __webpack_public_path__ + "static/media/toggle_cozy_Selected.73eec3c3.svg";